<template>
  <div class="outlet-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">

          <b-card>
            <div slot="header">
              {{$t('client.config')}}
            </div>
            <b-form class="row">
              <b-col cols="12">

                <b-form-group v-for="(option, i) in customer.list" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="customer.list[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>

                <b-form-group v-bind:label="$t('client.show_point')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="customer.config.show_point" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.show_full_address')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="customer.config.show_full_address" :value="true" :uncheckedValue="false"/>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.customization')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <customization v-model="customer.fields" :position_fields="position_fields"></customization>
              </b-col>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import cSwitch from '../../../components/Switch'
  import Customization from './Customization'

  export default {
    name: 'CustomerForm',
    props: {
      value: {
        type: Object
      }
    },
    components: {
      Customization,
      cSwitch
    },
    data: function () {
      return {
        position_fields: [
          'name_seo',
        ],
        customer: {
          basic_info: [],
          fields: [],
          config: {
            show_point: true,
            show_full_address: false
          },
          list: [
            {
              'name': 'WID',
              'type': 'wos_id',
              'show': false
            },
            {
              'name': 'Member ID',
              'type': 'id',
              'show': true
            },
            {
              'name': 'Name',
              'type': 'first_name',
              'show': true
            },
            {
              'name': 'Local Name',
              'type': 'local_first_name',
              'show': true
            },
            {
              'name': 'Phone',
              'type': 'phone',
              'show': true
            },
            {
              'name': 'Emails',
              'type': 'emails',
              'show': true
            },
            {
              'name': 'Email',
              'type': 'email',
              'show': true
            },
            {
              'name': 'Membership',
              'type': 'membership',
              'show': true
            }
          ]
        }
      }
    },
    methods: {
      updateData () {
        // Update Base Info
        if (this.value != null && this.value.basic_info != null) {
          let basicInfo = {}
          for (let i in this.value.basic_info) {
            basicInfo[this.value.basic_info[i].type] = {
              show: this.value.basic_info[i].show,
              disable: this.value.basic_info[i].disable
            }
          }

          for (let i in this.customer.basic_info) {
            if (basicInfo[this.customer.basic_info[i].type] != null) {
              this.customer.basic_info[i].show = basicInfo[this.customer.basic_info[i].type].show
              this.customer.basic_info[i].disable = basicInfo[this.customer.basic_info[i].type].disable
            }
          }
        }

        // Update List Info
        if (this.value != null && this.value.list != null) {
          let basicInfo = {}
          for (let i in this.value.list) {
            basicInfo[this.value.list[i].type] = {
              show: this.value.list[i].show,
              disable: this.value.list[i].disable
            }
          }

          for (let i in this.customer.list) {
            if (basicInfo[this.customer.list[i].type] != null) {
              this.customer.list[i].show = basicInfo[this.customer.list[i].type].show
              this.customer.list[i].disable = basicInfo[this.customer.list[i].type].disable
            }
          }
        }

        // Update Config
        if (this.value != null && this.value.config != null) {
          for (let i in this.customer.config) {
            if (this.value.config[i] != null) {
              this.customer.config[i] = this.value.config[i]
            }
          }
        }

        // Update customization field
        if (this.value != null && this.value.fields != null) {
          this.customer.fields = this.value.fields
        }
      }
    },
    created: function () {
    },
    mounted: function () {
      this.updateData()
    },
    watch: {
      customer: {
        handler: function (newValue) {
          this.$emit('input', this.customer)
          this.$emit('change', this.customer)
        },
        deep: true
      },
      value: {
        handler: function (newValue) {
          this.updateData()
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/admin/client/CustomerForm.vue